// extracted by mini-css-extract-plugin
export default {"banner":"EnvironmentBanner_banner__bvKvL","icon":"EnvironmentBanner_icon__Qx6KJ"};